import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';

const V1 = '/v1';
const FRAUD_FIGHTER_PATH = '/fraud-fighter';

const FetchLinkCreationBlockedStatus = new ReduxAsyncAction('FETCH_LINK_CREATION_BLOCKED_STATUS');
FetchLinkCreationBlockedStatus.registerRequest(async () => {
  const URI = `${V1}${FRAUD_FIGHTER_PATH}/link-creation-status`;
  const linkCreationStatus = await dash_api.get(URI);
  return linkCreationStatus.data;
});

export const FETCH_LINK_CREATION_BLOCKED_STATUS = FetchLinkCreationBlockedStatus.constants;
export const fetchLinkCreationBlockedStatus = FetchLinkCreationBlockedStatus.request;
